import React, { FC, memo } from 'react';

import classNames from 'classnames';
import { RadioGroup } from '@zvuk-b2b/ui-kit';

import { PlayButton } from 'application/components/PlayButton';

import PromoOptionProgress from '../../../ReportRequestForm/PromoSelector/PromoOptionProgress';
import { PROMO_STATUS_TITLE_BY_STATUS } from '../../../ReportRequestForm/PromoSelector/consts';

import { DATA_TEST_IDS } from '../../consts';
import type { DailyPromoOptionProps } from './types';

import styles from '../index.module.scss';

const DailyPromoOption: FC<DailyPromoOptionProps> = ({
  isCurrentPromo,
  isLoading,
  isPaused,
  isSelected,
  promo,
  onPlaybackToggle,
  onSelect,
}) => (
  <div
    className={styles.row}
    data-testid={DATA_TEST_IDS.PROMO_OPTION(promo.id)}>
    <RadioGroup
      value={isSelected ? String(promo.id) : null}
      onValueChange={() => onSelect(promo)}>
      <RadioGroup.Item
        value={String(promo.id)}
        disabled={!promo.mediafileId}
        data-testid={DATA_TEST_IDS.PROMO_OPTION_RADIO(promo.id)}
      />
    </RadioGroup>
    <button
      type="button"
      data-testid={DATA_TEST_IDS.PROMO_OPTION_PLAY(promo.id)}
      className={styles.playButton}
      disabled={!promo.audioUrl}
      onClick={() => onPlaybackToggle(promo)}>
      <PlayButton
        isLoading={isCurrentPromo && isLoading}
        isMediaFilePaused={isCurrentPromo && isPaused}
        isMediafilePlaying={isCurrentPromo}
      />
    </button>
    <button
      type="button"
      className={styles.option}
      disabled={!promo.mediafileId}
      onClick={() => onSelect(promo)}>
      <span className={styles.content}>
        <span className={styles.title}>{promo.title}</span>
        <span className={styles.campaign}>{promo.campaignTitle}</span>
      </span>
      <span className={styles.status}>
        <span className={classNames(styles.statusDot, styles[`statusDot${promo.status}`])} />
        {PROMO_STATUS_TITLE_BY_STATUS[promo.status]}
      </span>
      <PromoOptionProgress promoId={promo.id} />
    </button>
  </div>
);

export default memo(DailyPromoOption);
